var _circle, _rect, _rect2, _rect3, _mask, _path, _path2, _rect4, _path3, _path4, _rect5, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCollections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 174,
    viewBox: "0 0 200 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 87,
    fill: "url(#paint0_linear_2112_21705)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 69.5449,
    width: 133.562,
    height: 88.4556,
    rx: 2,
    fill: "#BDC3C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 59,
    width: 51.5503,
    height: 20.503,
    rx: 2,
    fill: "#BDC3C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6865,
    y: 79.5029,
    width: 124.189,
    height: 66.1953,
    rx: 2,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_2112_21705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 156C20.0004 157.105 20.8958 158 22.0004 158L151.562 158C152.667 158 153.563 157.105 153.563 156L153.563 98.4912C153.563 97.3867 152.667 96.4912 151.563 96.4912L22.0004 96.4912C20.8958 96.4912 20.0004 97.3866 20.0004 98.4912L20.0004 156Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 156C20.0004 157.105 20.8958 158 22.0004 158L151.562 158C152.667 158 153.563 157.105 153.563 156L153.563 98.4912C153.563 97.3867 152.667 96.4912 151.563 96.4912L22.0004 96.4912C20.8958 96.4912 20.0004 97.3866 20.0004 98.4912L20.0004 156Z",
    fill: "#D4D9DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 156C20.0004 158.209 21.7912 160 24.0004 160L149.562 160C151.772 160 153.562 158.209 153.563 156C153.563 156 152.667 156 151.563 156L22.0004 156C20.8958 156 20.0004 156 20.0004 156ZM153.563 96.4912L20.0004 96.4912L153.563 96.4912ZM20.0004 96.4912L20.0004 158L20.0004 96.4912ZM153.562 158L153.563 96.4912L153.562 158Z",
    fill: "#8E9EAE",
    mask: "url(#path-5-inside-1_2112_21705)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 51.5503,
    height: 20.503,
    rx: 2,
    transform: "matrix(-1 0 0 1 153.564 85.9473)",
    fill: "#D4D9DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.108 47.6877L174 44.2465L165.312 40.8843L161.776 31L158.328 40.6368L149 44.2465L158.532 47.9352L161.776 57L165.108 47.6877Z",
    fill: "#BDC3C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.639 151.306C174.843 151.867 190.051 137.931 190.608 120.178C191.164 102.425 176.859 87.5787 158.655 87.017C140.452 86.4553 125.244 100.392 124.687 118.144C124.13 135.897 138.436 150.744 156.639 151.306ZM156.863 144.163C171.021 144.6 182.85 133.761 183.283 119.953C183.716 106.145 172.59 94.598 158.431 94.1611C144.273 93.7243 132.444 104.564 132.011 118.371C131.578 132.179 142.705 143.727 156.863 144.163Z",
    fill: "#BDC3C8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.8253,
    height: 33.8182,
    rx: 3.91265,
    transform: "matrix(0.835144 -0.550467 0.569767 0.82151 168.974 144.646)",
    fill: "#BDC3C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.266 151.637L181.035 146.516L195.374 167.191C196.004 168.098 195.766 169.327 194.844 169.935L190.415 172.854C189.493 173.462 188.235 173.219 187.606 172.312L173.266 151.637Z",
    fill: "#5E6974"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2112_21705",
    x1: 68,
    y1: -296,
    x2: 87,
    y2: 243.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCollections);
export default __webpack_public_path__ + "static/media/no-collections.66984c65566cf8d46aa75142e45e407d.svg";
export { ForwardRef as ReactComponent };